import { createSelector } from 'reselect'

const getFeatureFlagsHash = state => state.user.featureFlagsHash

export default createSelector(
	[ getFeatureFlagsHash ],
	featureFlagsHash => featureFlagsHash
)
